/**
 * ComfyUI 마크(각진 "C") — GNB의 lucide 아이콘들과 같은 **외곽선** 스타일.
 *
 * 원본 경로 출처: lobehub/lobe-icons `packages/static-svg/icons/comfyui.svg`.
 * 원본은 채워진 실루엣이라 stroke 아이콘들 사이에서 혼자 튄다. 그래서 같은 경로를
 * fill 없이 stroke로만 그린다.
 *
 * 크기·굵기를 lucide에 맞추기 위한 두 가지 보정:
 *  - transform scale(0.85): 원본 bbox가 22.1x23.5로 24 박스를 거의 꽉 채운다.
 *    lucide는 20 남짓만 쓰고 여백을 두므로 줄여서 여백을 만든다.
 *  - strokeWidth 2.1: scale 안쪽이라 실제로는 약 1.8로 그려진다. lucide의 2보다
 *    살짝 가볍게 둔 것은, 실루엣 외곽선이 이중선이라 같은 굵기면 더 빽빽해 보이기 때문이다.
 */
export function ComfyUiIcon({ size = 24, ...props }: { size?: number } & React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height={size}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2.1}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g transform="translate(2.18 1.84) scale(0.85)">
        <path d="M5.485 23.76c-.568 0-1.026-.207-1.325-.598-.307-.402-.387-.964-.22-1.54l.672-2.315a.605.605 0 00-.1-.536.622.622 0 00-.494-.243H2.085c-.568 0-1.026-.207-1.325-.598-.307-.403-.387-.964-.22-1.54l2.31-7.917.255-.87c.343-1.18 1.592-2.14 2.786-2.14h2.313c.276 0 .519-.18.595-.442l.764-2.633C9.906 1.208 11.155.249 12.35.249l4.945-.008h3.62c.568 0 1.027.206 1.325.597.307.402.387.964.22 1.54l-1.035 3.566c-.343 1.178-1.593 2.137-2.787 2.137l-4.956.01H11.37a.618.618 0 00-.594.441l-1.928 6.604a.605.605 0 00.1.537c.118.153.3.243.495.243l3.275-.006h3.61c.568 0 1.026.206 1.325.598.307.402.387.964.22 1.54l-1.036 3.565c-.342 1.179-1.592 2.138-2.786 2.138l-4.957.01h-3.61z" />
      </g>
    </svg>
  );
}
